// extracted by mini-css-extract-plugin
export default {"info":"style_info__hkwBC","info_link":"style_info_link__INHLF"};